// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from 'D:/fe-dx-agent/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@ant-design/pro-layout/es/PageLoading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 't__plugin-layout__Layout' */'D:/fe-dx-agent/src/.umi-production/plugin-layout/Layout.tsx'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/user",
        "layout": false,
        "routes": [
          {
            "path": "/user/login",
            "layout": false,
            "name": "登录",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__User__login__index' */'D:/fe-dx-agent/src/pages/User/login/index'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'D:/fe-dx-agent/src/pages/404'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "name": "个人页",
        "icon": "user",
        "path": "/account",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__TabsLayout' */'@/layouts/TabsLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "个人中心",
            "icon": "smile",
            "path": "/account/center",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__account__center__index' */'D:/fe-dx-agent/src/pages/account/center/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "个人中心",
            "exact": true
          }
        ]
      },
      {
        "icon": "BugOutlined",
        "path": "/system",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__TabsLayout' */'@/layouts/TabsLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "icon": "PartitionOutlined",
            "path": "/system/dept",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__system__dept__index' */'D:/fe-dx-agent/src/pages/system/dept/index'), loading: LoadingComponent}),
            "access": "authorize",
            "title": "机构部门管理",
            "name": "机构部门管理",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "exact": true
          },
          {
            "icon": "PartitionOutlined",
            "path": "/system/user",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__system__user__index' */'D:/fe-dx-agent/src/pages/system/user/index'), loading: LoadingComponent}),
            "access": "authorize",
            "title": "个人用户管理",
            "name": "个人用户管理",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "exact": true
          },
          {
            "icon": "PartitionOutlined",
            "path": "/system/menu",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__system__menu__index' */'D:/fe-dx-agent/src/pages/system/menu/index'), loading: LoadingComponent}),
            "access": "authorize",
            "title": "菜单管理",
            "name": "菜单管理",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "exact": true
          },
          {
            "icon": "PartitionOutlined",
            "path": "/system/role",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__system__role__index' */'D:/fe-dx-agent/src/pages/system/role/index'), loading: LoadingComponent}),
            "access": "authorize",
            "title": "角色管理",
            "name": "角色管理",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "exact": true
          },
          {
            "icon": "BugOutlined",
            "path": "/system/log",
            "routes": [
              {
                "icon": "PartitionOutlined",
                "path": "/system/log/operlog",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__monitor__operlog__index' */'D:/fe-dx-agent/src/pages/monitor/operlog/index'), loading: LoadingComponent}),
                "access": "authorize",
                "title": "操作日志",
                "name": "操作日志",
                "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
                "keepAlive": false,
                "exact": true
              },
              {
                "icon": "PartitionOutlined",
                "path": "/system/log/logininfor",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__monitor__logininfor__index' */'D:/fe-dx-agent/src/pages/monitor/logininfor/index'), loading: LoadingComponent}),
                "access": "authorize",
                "title": "登录日志",
                "name": "登录日志",
                "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
                "keepAlive": false,
                "exact": true
              }
            ]
          },
          {
            "icon": "PartitionOutlined",
            "path": "/system/monitor/online",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__monitor__online__index' */'D:/fe-dx-agent/src/pages/monitor/online/index'), loading: LoadingComponent}),
            "access": "authorize",
            "title": "在线用户",
            "name": "在线用户",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "exact": true
          }
        ]
      },
      {
        "icon": "BugOutlined",
        "path": "/statisticalAnalysis",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__TabsLayout' */'@/layouts/TabsLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "icon": "PartitionOutlined",
            "path": "/statisticalAnalysis/query",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__statisticalAnalysis__query__index' */'D:/fe-dx-agent/src/pages/statisticalAnalysis/query/index'), loading: LoadingComponent}),
            "access": "authorize",
            "title": "智能专家问答查询",
            "name": "智能专家问答查询",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "exact": true
          }
        ]
      },
      {
        "name": "图表",
        "path": "/charts",
        "layout": false,
        "routes": [
          {
            "path": "/charts/map/:uuid",
            "layout": false,
            "hideInMenu": true,
            "name": "位置地图",
            "title": "位置地图",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__charts__map__index' */'D:/fe-dx-agent/src/pages/charts/map/index'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "name": "知识库",
        "path": "/fileManagement",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__TabsLayout' */'@/layouts/TabsLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "上传文件库",
            "path": "/fileManagement/files",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__filesManage__index' */'D:/fe-dx-agent/src/pages/filesManage/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "上传文件库",
            "exact": true
          },
          {
            "name": "生成文件库",
            "path": "/fileManagement/generateFileLibrary",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__generateFileLibrary__index' */'D:/fe-dx-agent/src/pages/generateFileLibrary/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "生成文件库",
            "exact": true
          },
          {
            "name": "个人知识库",
            "path": "/fileManagement/personal",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__personalKnowledgeBase__index' */'D:/fe-dx-agent/src/pages/personalKnowledgeBase/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "个人知识库",
            "exact": true
          }
        ]
      },
      {
        "name": "政策标准知识库",
        "path": "/policyKnowledgeBase",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__TabsLayout' */'@/layouts/TabsLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "政策知识库",
            "path": "/policyKnowledgeBase/index",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__policyKnowledgeBase__search__index' */'D:/fe-dx-agent/src/pages/policyKnowledgeBase/search/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "政策知识库",
            "exact": true
          },
          {
            "name": "政策问答集",
            "path": "/policyKnowledgeBase/questionsAndAnswers",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__policyQAndA__index' */'D:/fe-dx-agent/src/pages/policyQAndA/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "政策问答集",
            "exact": true
          },
          {
            "name": "政策知识图谱",
            "path": "/policyKnowledgeBase/graphPreview",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__policyGraphPreview__index' */'D:/fe-dx-agent/src/pages/policyGraphPreview/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "政策知识图谱",
            "exact": true
          },
          {
            "path": "/policyKnowledgeBase/policyMaintenance",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__policyMaintenance__index' */'D:/fe-dx-agent/src/pages/policyMaintenance/index'), loading: LoadingComponent}),
            "access": "authorize",
            "title": "政策知识库维护",
            "name": "政策知识库维护",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "hideInMenu": true,
            "keepAlive": false,
            "exact": true
          }
        ]
      },
      {
        "name": "政策单页详情",
        "path": "/policyRelated",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__TabsLayout' */'@/layouts/TabsLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "片段查看",
            "path": "/policyRelated/policyFileDetail/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__policyFileDetail__index' */'D:/fe-dx-agent/src/pages/policyFileDetail/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "片段查看",
            "exact": true
          },
          {
            "name": "政策详情",
            "path": "/policyRelated/policyDetail/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__policyKnowledgeBase__details__index' */'D:/fe-dx-agent/src/pages/policyKnowledgeBase/details/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "政策详情",
            "exact": true
          },
          {
            "name": "问答详情",
            "path": "/policyRelated/policyQAndADetail/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__policyQAndADetail__index' */'D:/fe-dx-agent/src/pages/policyQAndADetail/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "问答详情",
            "exact": true
          },
          {
            "icon": "PartitionOutlined",
            "path": "/policyRelated/clipEditing/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__policyMaintenanceDetail__index' */'D:/fe-dx-agent/src/pages/policyMaintenanceDetail/index'), loading: LoadingComponent}),
            "access": "authorize",
            "title": "片段编辑",
            "name": "片段编辑",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "exact": true
          }
        ]
      },
      {
        "name": "应用",
        "path": "/app",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__TabsLayout' */'@/layouts/TabsLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "智能专家",
            "path": "/app/chat",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiChat__index' */'D:/fe-dx-agent/src/pages/aiChat/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "智能专家",
            "exact": true
          },
          {
            "name": "个人文件库",
            "path": "/app/files",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__filesManage__index' */'D:/fe-dx-agent/src/pages/filesManage/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "个人文件库",
            "exact": true
          },
          {
            "name": "生成文件库",
            "path": "/app/generateFileLibrary",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__generateFileLibrary__index' */'D:/fe-dx-agent/src/pages/generateFileLibrary/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "生成文件库",
            "exact": true
          },
          {
            "name": "助手管理",
            "path": "/app/build",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__build__index' */'D:/fe-dx-agent/src/pages/build/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "助手管理",
            "exact": true
          },
          {
            "name": "知识库管理",
            "path": "/app/dataset",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__dataset__index' */'D:/fe-dx-agent/src/pages/dataset/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "知识库管理",
            "exact": true
          },
          {
            "name": "知识图谱",
            "path": "/app/graph",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__graph__index' */'D:/fe-dx-agent/src/pages/graph/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "知识图谱",
            "exact": true
          },
          {
            "name": "知识图谱详情",
            "path": "/app/graphDetail/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__graphDetail__index' */'D:/fe-dx-agent/src/pages/graphDetail/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "知识图谱详情",
            "exact": true
          },
          {
            "name": "知识图谱文件详情",
            "path": "/app/graphFileDetail/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__graphFileDetail__index' */'D:/fe-dx-agent/src/pages/graphFileDetail/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "知识图谱文件详情",
            "exact": true
          },
          {
            "name": "知识图谱预览",
            "path": "/app/graphPreview/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__graphPreview__index' */'D:/fe-dx-agent/src/pages/graphPreview/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "知识图谱预览",
            "exact": true
          },
          {
            "name": "知识库详情",
            "path": "/app/datasetDetail/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__datasetDetail__index' */'D:/fe-dx-agent/src/pages/datasetDetail/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "知识库详情",
            "exact": true
          },
          {
            "name": "内嵌页测试",
            "path": "/app/webview",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__iframeContainer__index' */'D:/fe-dx-agent/src/pages/iframeContainer/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/components/KeepAlive'), loading: LoadingComponent})],
            "keepAlive": false,
            "hideInMenu": true,
            "title": "内嵌页测试",
            "exact": true
          }
        ]
      },
      {
        "path": "/index.html",
        "redirect": "/system/user",
        "exact": true
      },
      {
        "path": "/",
        "redirect": "/system/user",
        "exact": true
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'D:/fe-dx-agent/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
